import { render, staticRenderFns } from "./customer-setting.vue?vue&type=template&id=177074b2&scoped=true&"
import script from "./customer-setting.vue?vue&type=script&lang=js&"
export * from "./customer-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177074b2",
  null
  
)

export default component.exports